var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContact = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#35B94E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7432 27.7676H32.2552C28.7967 27.7676 25.4795 29.1398 23.0317 31.5831C20.5839 34.0264 19.2056 37.3411 19.1992 40.7996V73.1996C19.1992 76.6622 20.5748 79.9831 23.0232 82.4316C25.4717 84.88 28.7926 86.2556 32.2552 86.2556H35.9992V103.452L53.1952 86.2556H87.7792C91.2232 86.2461 94.524 84.8763 96.9626 82.4444C99.4013 80.0125 100.78 76.7155 100.799 73.2716V40.7996C100.793 37.3411 99.4145 34.0264 96.9667 31.5831C94.519 29.1398 91.2017 27.7676 87.7432 27.7676Z",
    fill: "#E9FFEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6004 41.7959H32.4004C30.7435 41.7959 29.4004 43.139 29.4004 44.7959V45.1679C29.4004 46.8248 30.7435 48.1679 32.4004 48.1679H87.6004C89.2572 48.1679 90.6004 46.8248 90.6004 45.1679V44.7959C90.6004 43.139 89.2572 41.7959 87.6004 41.7959Z",
    fill: "#32DBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6004 54.5518H32.4004C30.7435 54.5518 29.4004 55.8949 29.4004 57.5518V57.9238C29.4004 59.5806 30.7435 60.9238 32.4004 60.9238H87.6004C89.2572 60.9238 90.6004 59.5806 90.6004 57.9238V57.5518C90.6004 55.8949 89.2572 54.5518 87.6004 54.5518Z",
    fill: "#116EEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6004 67.2959H32.4004C30.7435 67.2959 29.4004 68.639 29.4004 70.2959V70.6679C29.4004 72.3247 30.7435 73.6679 32.4004 73.6679H87.6004C89.2572 73.6679 90.6004 72.3247 90.6004 70.6679V70.2959C90.6004 68.639 89.2572 67.2959 87.6004 67.2959Z",
    fill: "#F25112"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Contact.07d7119959118052498a40ee8181c3ca.svg";